import React from "react";
import { Archive, Inbox as InboxIcon } from "lucide-react";

interface EmptyStateProps {
  tab: "inbox" | "history";
}

/**
 * Full-height empty state shown in the notification sheet when a tab has
 * no items to render. Inbox copy is upbeat ("All caught up!"); history
 * copy is informative ("Archived notifications will appear here.").
 */
export function EmptyState({ tab }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center h-full">
      <div className="h-14 w-14 rounded-2xl bg-muted flex items-center justify-center mb-4">
        {tab === "inbox" ? (
          <InboxIcon className="h-7 w-7 text-muted-foreground/50" />
        ) : (
          <Archive className="h-7 w-7 text-muted-foreground/50" />
        )}
      </div>
      <p className="text-sm font-semibold">
        {tab === "inbox" ? "All caught up!" : "No archived notifications"}
      </p>
      <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed max-w-[220px]">
        {tab === "inbox"
          ? "You have no pending notifications right now."
          : "Archived notifications will appear here."}
      </p>
    </div>
  );
}
